{
  "created_by": "Criado por",
  "created": "Criado",
  "filter": "Filtro",
  "example": {
    "test": "Meu nome é {{ name }} e eu tenho {{ age }} anos"
  },
  "buttons": {
    "cancel": "Cancelar",
    "save": "Salvar",
    "save_changes": "Salvar alterações",
    "next": "Próximo",
    "continue": "Continuar",
    "close": "Fechar",
    "selectValue": "Selecione {{ value }}",
    "remove": "Remover",
    "confirm": "Confirmar",
    "saveAndFinish": "Salvar e finalizar",
    "saveAndClose": "Salvar e fechar",
    "back": "Voltar",
    "copyValue": "Valor da cópia",
    "pasteValue": "Colar valor",
    "delete": "Excluir",
    "deleting": "Excluindo",
    "deleteAll": "Excluir tudo",
    "undo": "Desfazer",
    "redo": "Refazer",
    "import": "Importar",
    "export": "Exportar",
    "add": "Adicionar",
    "share": "Compartilhar",
    "key": "Chave",
    "create": "Criar",
    "expand": "Expandir",
    "collapse": "Colapso",
    "select": "Selecione",
    "select_all": "Selecionar tudo",
    "upload": "Carregar",
    "download": "Baixar",
    "add_another_item": "Adicionar outro item",
    "move": "Mova-se",
    "edit": "Editar",
    "edit_name": "Editar nome",
    "removeImage": "Remover imagem",
    "finish": "Concluir",
    "click_to_edit": "Clique para editar {{ name }}",
    "click_to_select": "Clique para selecionar {{ name }}",
    "click_to_deselect": "Clique para desmarcar {{ name }}",
    "see_all": "Veja tudo",
    "skip": "Ignorar",
    "submit": "Enviar",
    "support": "Contate o suporte",
    "upgrade": "Atualizar",
    "createLayer": "Criar camada",
    "disable": "Desabilitar",
    "enable": "Habilitar",
    "copy": "Copiar",
    "maximise": "Maximizar",
    "minimise": "Minimizar",
    "retry": "Tente novamente"
  },
  "toasts": {
    "creating_resource": "Criando {{ resource }} Nós lhe diremos quando estiver pronto",
    "creation_completed": "Criação concluída para {{ resource }}",
    "resource_complete": "{{ resource }} completo"
  },
  "selected": "Selecionado {{ selectedNumber }}",
  "no_children_available": "Nenhum {{ childType }} disponível",
  "loading...": "Carregando...",
  "saving": "Salvando",
  "pending_save": "Salvamento pendente",
  "saved": "Salvo",
  "creating": "Criando",
  "errorLoading": "Erro ao carregar {{ resourceName }}",
  "yes": "sim",
  "no": "Não",
  "none": "Nenhum",
  "selection": {
    "none_selected": "Nenhum selecionado",
    "all_selected": "Todos selecionados",
    "selected": "Selecionado"
  },
  "upload": {
    "select_csv": "Selecione o arquivo CSV",
    "change_csv": "Alterar arquivo CSV",
    "upload_errors_placeholder": "Se houver algum problema com seu arquivo, eles aparecerão aqui",
    "import_complete": "Importação concluída com sucesso"
  },
  "sort": {
    "most_relevant": "Mais relevante"
  },
  "settings": "Configurações",
  "no_results": "Sem resultados",
  "name": "Nome",
  "in_development": "[Em desenvolvimento]",
  "exports": {
    "success_message": "{{ exportName }} foi exportado com sucesso. Clique no link para baixá-lo",
    "error_message": "{{ exportName }} falhou ao exportar. Tente novamente mais tarde ou entre em contato com o suporte da Iventis.",
    "start_message": "A exportação de {{ exportName }} começou, avisaremos quando estiver pronta"
  },
  "all": "Todos",
  "copied_to_clipboard": "Copiado para a prancheta",
  "click_for_details": {
    "whole": "Clique aqui para obter mais detalhes",
    "click": "Clique",
    "for_more": "para obter mais detalhes"
  },
  "here": "aqui",
  "delete_confirmation_message": "Tem certeza de que deseja excluir {{ entity }}",
  "unavailable": "Indisponível",
  "link": "Link",
  "powered_by": "Desenvolvido por",
  "boolean": {
    "true": "Verdadeira",
    "false": "Falso"
  },
  "delete": "Excluir",
  "learnMore": "Saiba mais",
  "items": "itens",
  "csv": "csv",
  "success": "Sucesso",
  "alert": "Alerta",
  "warning": "Aviso",
  "error": "Erro"
}